import { render, staticRenderFns } from "./productDialog2.vue?vue&type=template&id=4acd1a76&scoped=true"
import script from "./productDialog2.vue?vue&type=script&lang=js"
export * from "./productDialog2.vue?vue&type=script&lang=js"
import style0 from "./productDialog2.vue?vue&type=style&index=0&id=4acd1a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd1a76",
  null
  
)

export default component.exports